import React from "react";
import { FieldArray, ErrorMessage } from 'formik';
import { UserContext } from '../../contexts';
import { deleteChildren, deleteContact } from '../services'
import MyProfile from './MyProfile';
import CustomErrorMessage from '../CustomErrorMessage';
import {
  // Nav,
  // NavItem,
  // NavLink,
  Card,
  Button,
  // CardTitle,
  // CardText,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  // FormText,
  CardBody
} from "reactstrap";
import DatePicker from 'react-datepicker';
// import { Link } from "react-router-dom";

import "./Account.css";



class Profile extends React.Component {

  // constructor(props) {
  //   super(props);

  //   this.state = {}
  // }

  handleChildRemove = async (index, arrayHelpers) => {
    
    let child = this.props.values.children[index];

    if(child._id !== undefined) {

      const response = await deleteChildren({data: { childId: child._id }}); 
      
      if(response.status !== 200) {
        return
      }
    }  
    
    arrayHelpers.remove(index);
  }

  handleContactRemove = async (index, arrayHelpers) => {
    
    let contact = this.props.values.contacts[index];

    if(contact._id !== undefined) {

      const response = await deleteContact({data: {contactId: contact._id}});
      
      if(response.status !== 200) {
        return
      }
    }

    arrayHelpers.remove(index);
  }

  render() {
    const {errors, touched} = this.props;

    return (
      <div className="mt-4 account-edit">
        <UserContext.Consumer>
          {value => {
            return (
              <MyProfile
                username={this.props.fullName}
                changeAvatar={value.changeAvatar}
                profilePicture={this.props.profilePicture}
                showLinks={true}
                lifeStage={this.props.lifeStage}
              />
            )
          }}
        </UserContext.Consumer>
        <Card className="account-card">
          <CardBody>
            <Form onSubmit={this.props.handleSubmit}>
              <Row>
                <Col md={{ size: 4 }}>
                  <FormGroup>
                    <Label>Full Name</Label>
                    <Input
                      type="text"
                      name="fullName"
                      placeholder="Full Name"
                      value={this.props.values.fullName}
                      onChange={this.props.handleChange}
                    />
                    {errors.fullName && touched.fullName && <div id="feedback" className="text-danger">{errors.fullName}</div>}
                  </FormGroup>
                </Col>
                <Col>
                  {/* <FormGroup>
                    <Label>Additional Phone Number(Optional)</Label>
                    <Input type="text" 
                      name="phone2" 
                      value={this.props.values.phone2}
                      onChange={this.props.handleChange}
                    />
                    {errors.phone2 && touched.phone2 && <div id="feedback" className="text-danger">{errors.phone2}</div>}
                  </FormGroup> */}
                  <FormGroup>
                    <Label>D.O.B</Label>
                    <DatePicker 
                      selected={this.props.values.dob}
                      onChange={date => this.props.setFieldValue("dob", date)}
                      maxDate={new Date()}
                    />
                    {/* <Input type="date" 
                      name="dob"
                      value={this.props.values.dob}
                      onChange={this.props.handleChange}
                    /> */}
                    {errors.dob && touched.dob && <div id="feedback" className="text-danger">{errors.dob}</div>}
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup style={{ marginBottom: 0, paddingBottom: 0 }}>
                    <Label>Gender</Label>
                  </FormGroup>
                  <FormGroup>
                    <FormGroup check inline>
                      <Input
                        className="form-check-input"
                        type="radio"
                        id="inline-radio1"
                        name="gender"
                        value="1"
                        checked={this.props.values.gender == "1"}
                        onChange={() => this.props.setFieldValue("gender", "1")}
                      />
                      <Label
                        className="form-check-label"
                        check
                      >
                        Male
                      </Label>
                    </FormGroup>
                    <FormGroup check inline>
                      <Input
                        className="form-check-input"
                        type="radio"
                        id="inline-radio2"
                        name="gender"
                        value="2"
                        checked={this.props.values.gender == "2"}
                        onChange={() => this.props.setFieldValue("gender", "2")}
                      />
                      <Label
                        className="form-check-label"
                        check
                      >
                        Female
                      </Label>
                    </FormGroup>
                  </FormGroup>
                </Col>
              </Row>
              <br />
              <p>
                <b>Family Details</b>
              </p>
              <hr />
              <FieldArray 
                name="children"
                values={this.props.values}
                handleChange={this.props.handleChange}
                setFieldValue={this.props.setFieldValue}
                render={arrayHelpers => (
                  <div>
                    {this.props.values.children && this.props.values.children.length > 0 ? (
                      this.props.values.children.map((child, index) => (
                        <div className="row" key={index}>
                          <div className="col-xs-12 col-md-3">
                            <FormGroup>
                              <Label>Child {index+1} Detail</Label>
                              <Input
                                type="text"
                                value={this.props.values.children[index].name}
                                name={`children.${index}.name`}
                                placeholder="Full Name"
                                onChange={this.props.handleChange}
                              />
                              <CustomErrorMessage name={`children.${index}.name`}/>
                            </FormGroup>
                          </div>
                          <div className="col-xs-12 col-md-3">
                            <FormGroup>
                              <Label>D.O.B</Label>
                              <DatePicker 
                                selected={this.props.values.children[index].dob}
                                onChange={date => this.props.setFieldValue(`children.${index}.dob`, date)}
                                maxDate={new Date()}
                              />
                              <CustomErrorMessage name={`children.${index}.dob`}/>
                            </FormGroup>
                          </div>
                          <div className="col-xs-12 col-md-3">
                            <FormGroup style={{ marginBottom: 0, paddingBottom: 0 }}>
                              <Label>Gender</Label>
                            </FormGroup>
                            <FormGroup row>
                              <Col md="9">
                                <FormGroup check inline>
                                  <Input
                                    className="form-check-input"
                                    type="radio"
                                    // id="inline-radio1"
                                    name={`children.${index}.gender`}
                                    value="1"
                                    checked={this.props.values.children[index].gender == "1"}
                                    onChange={() => this.props.setFieldValue(`children.${index}.gender`, "1")}
                                  />
                                  <Label
                                    className="form-check-label"
                                    check
                                  >
                                    Male
                                  </Label>
                                </FormGroup>
                                <FormGroup check inline>
                                  <Input
                                    className="form-check-input"
                                    type="radio"
                                    // id="inline-radio2"
                                    name={`children.${index}.gender`}
                                    value="2"
                                    checked={this.props.values.children[index].gender == "2"}
                                    onChange={() => this.props.setFieldValue(`children.${index}.gender`, "2")}
                                  />
                                  <Label
                                    className="form-check-label"
                                    check
                                  >
                                    Female
                                  </Label>
                                </FormGroup>
                              </Col>
                            </FormGroup>
                          </div>
                          <div className="col-md-3">
                            <Button onClick={(e) => this.handleChildRemove(index, arrayHelpers)}>Remove</Button>
                          </div>
                        </div>                      
                      ))
                    ) : <div></div>}
                    <div className="row">
                      <div className="col-xs-5 col-md-4">
                        <Button className="" 
                          onClick={() => arrayHelpers.push({
                            name: '',
                            dob: '',
                            gender: ''
                          })}
                        >Add Child
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
              />
              <br />
              <p>
                <b>Contact Details</b>
              </p>
              <hr />
              <FieldArray 
                name="contacts"
                values={this.props.values}
                handleChange={this.props.handleChange}
                setFieldValue={this.props.setFieldValue}
                render={arrayHelpers => (
                  <div>
                    {this.props.values.contacts ? this.props.values.contacts.map((contact, index) => (
                      <div className="row" key={index}>
                        <div className="col-sm-12 col-md-3">
                          <FormGroup>
                            <Label>Contact {index+1} Detail</Label>
                            <Input
                              type="text"
                              value={this.props.values.contacts[index].name}
                              name={`contacts.${index}.name`}
                              placeholder="Full Name"
                              onChange={this.props.handleChange}
                            />
                            <CustomErrorMessage name={`contacts.${index}.name`}/>
                          </FormGroup>
                        </div>
                        <div className="col-sm-12 col-md-3">
                          <FormGroup>
                            <Label>Phone</Label>
                            <Input type="text" 
                              name={`contacts.${index}.phone`}
                              value={this.props.values.contacts[index].phone}
                              onChange={this.props.handleChange}
                            />
                            <CustomErrorMessage name={`contacts.${index}.phone`}/>
                          </FormGroup>
                        </div>
                        <div className="col-sm-12 col-md-3">
                          <FormGroup style={{ marginBottom: 0, paddingBottom: 0 }}>
                            <Label>Email</Label>
                            <Input type="text" 
                              name={`contacts.${index}.email`}
                              value={this.props.values.contacts[index].email}
                              onChange={this.props.handleChange}
                            />
                            <CustomErrorMessage name={`contacts.${index}.email`}/>                            
                          </FormGroup>          
                        </div>
                        <div className="col-sm-12 col-md-3 mt-3">
                          <Button onClick={(e) => this.handleContactRemove(index, arrayHelpers)}>Remove</Button>
                        </div>
                      </div>
                    )) : <div></div> }
                    <div className="row">
                      <div className="col-xs-5 col-md-4">
                        <Button className="" 
                          onClick={() => arrayHelpers.push({
                            name: '',
                            phone: '',
                            email: ''
                          })}
                        >Add Contact
                        </Button>
                      </div>
                    </div>
                  </div>                   
                )}
              />
              <div className="text-center mt-4 pb-5">
                <Button className="btn text-center" style={{ width: "108px" }} type="submit">
                  Save
                </Button>
              </div>              
            </Form>
          </CardBody>
        </Card>
      </div>
    );
  }
}



export default Profile;



// WEBPACK FOOTER //
// ./src/views/Account/Profile.js